import { render, staticRenderFns } from "./UCSwitch.vue?vue&type=template&id=513c6fdc&scoped=true&"
import script from "./UCSwitch.vue?vue&type=script&lang=ts&"
export * from "./UCSwitch.vue?vue&type=script&lang=ts&"
import style0 from "./UCSwitch.vue?vue&type=style&index=0&id=513c6fdc&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "513c6fdc",
  null
  
)

export default component.exports